



















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormPage from "./FormPage/index.vue";
import ChartPage from "../../../components/ChartPage/index.vue";
import { getCookie } from "@szgc/plt-core-v2";
import Api from "../../../api/index";
import request from "../../../api/request";
import LogTable from "../../../components/LogTable/index.vue";
import { dateFormat } from "../../../util";
import FileList from "../../../components/FileList/index.vue";
import UploadFile from "../../../../pt/components/UploadFile/index.vue";

@Component({
  name: "WbenCopyProcessMobile",
  components: {
    UploadFile,
    FormPage,
    ChartPage,
    LogTable,
    FileList
  }
})
export default class WbenCopyProcessMobile extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: [String, Number],
    default: "all"
  })
  private logType!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessId: any = null;
  private processData: any = null;
  private flowData: any = null;
  private title: any = "";
  private userName: any = "";
  private timeText: any = "";
  private prefix: string = "";
  private fileData: any = [];
  private iframeUrl: string = "";
  private iframeHeight: string = "0px";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.businessId = this.processData.businessId;
      this.getFlowData();
    }
  }

  /*抄送的流程事项数据查询*/
  async getFlowData() {
    const params = {
      businessId: this.processData.businessId,
      clientType: "web",
      procTaskId: this.processData.procTaskId
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getCopyDetail(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取抄送的流程事项数据失败:" + message);
        return false;
      }
      this.title = data.businessName;
      this.userName = data.run.createUserName;
      this.timeText = data.run.createTime ? dateFormat(data.run.createTime) : "--";
      this.flowData = data;
      this.fileData = data.atts;
      if (this.flowData.packageType === 3) {
        const iframeConfig: any = JSON.parse(this.flowData.fields.iframe.value);
        const path = iframeConfig.web;
        if (path.indexOf("http:") > -1 || path.indexOf("https:") > -1) {
          this.iframeUrl = path + "?businessId=" + this.businessId;
        } else {
          this.iframeUrl = window.origin + (path + "?businessId=" + this.businessId);
        }
        this.iframeHeight = iframeConfig.padHeight + "px";
      }
    } catch (error: any) {
      this.$message.error("获取抄送的流程事项数据失败:" + error);
    }
  }
}
